var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextLink = function SvgTextLink(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M11.709 9.47a4.16 4.16 0 0 0-4.066-1.827A4.148 4.148 0 0 0 5.285 8.82L4.107 10A4.167 4.167 0 1 0 10 15.892l.589-.589M8.29 10.53a4.16 4.16 0 0 0 4.066 1.827 4.148 4.148 0 0 0 2.357-1.179L15.892 10A4.167 4.167 0 1 0 10 4.107l-.59.59"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextLink);
export default ForwardRef;